var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Grid',{staticClass:"modal-footer q-py-md q-px-xxl bg-white-1 shadow6",attrs:{"gaf":"column","justify-content":"end","align-items":"center","gap":"var(--r-space-md)"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }